// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__oxK-D","dragIcon":"Choice_dragIcon__1EDGh","left":"Choice_left__36m_c","input":"Choice_input__1C5Ee"};